import { render, staticRenderFns } from "./MyWorld.vue?vue&type=template&id=0da1c092&scoped=true"
import script from "./MyWorld.vue?vue&type=script&lang=js"
export * from "./MyWorld.vue?vue&type=script&lang=js"
import style0 from "./MyWorld.vue?vue&type=style&index=0&id=0da1c092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da1c092",
  null
  
)

export default component.exports